export default "__VITE_ASSET__BJTlvBQJ__"